import { useState } from 'react'
import SVG from 'react-inlinesvg'
import { useTranslation } from 'react-i18next'
import { useContextPanels } from '../../contexts/panelsContext'
import { UIElement } from '../../types/UIElements'
import { useEnv } from '../../utils/useEnv'
import { TotalMotifCount } from './TotalMotifCount'
import { cn } from '../../utils/cn'

type Corner = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'

const cornerClassNames: Record<Corner, string> = {
  'top-left': 'left-[-20px] top-[-20px] rounded-tl-[20px]',
  'top-right': 'right-[-20px] top-[-20px] rounded-tr-[20px]',
  'bottom-left': 'bottom-[-20px] left-[-20px] rounded-bl-[20px]',
  'bottom-right': 'bottom-[-20px] right-[-20px] rounded-br-[20px]',
}

const CornerDecoration = ({ corner }: { corner: Corner }) => (
  <div className={cn('absolute size-[112px] bg-black', cornerClassNames[corner])} />
)

const Welcome = () => {
  const { t, i18n } = useTranslation()

  const [fadeOut, setFadeOut] = useState<boolean>(false)
  const { isPanelOpen, closeAll } = useContextPanels()
  const { isKiosk } = useEnv()

  const onClick = () => {
    setFadeOut(true)
    setTimeout(() => {
      setFadeOut(false)
      closeAll()
    }, 500)
  }

  return isPanelOpen(UIElement.WELCOME) ? (
    <div
      onClick={onClick}
      className={cn(
        'absolute left-0 top-0 flex h-full w-screen items-center justify-center opacity-0 [transition:opacity_0.3s] [&.fade-in]:opacity-100 [&.fade-out]:animate-[fade-out-y-10p_0.8s_ease_forwards] [&.kiosk]:select-none',
        { 'fade-out': fadeOut, kiosk: isKiosk },
        'fade-in',
      )}
    >
      <div className="relative h-[484px] w-[580px] [transform:scale(0.42)] sm:[transform:scale(0.8)] lg:[transform:scale(1)]">
        <CornerDecoration corner="top-left" />
        <CornerDecoration corner="top-right" />
        <CornerDecoration corner="bottom-left" />
        <CornerDecoration corner="bottom-right" />

        <div className="absolute grid h-full w-full rounded-[12px] bg-white [place-items:center]">
          <div className="flex flex-col items-center gap-[16px]">
            <SVG
              className="mb-[16px] h-auto w-full font-approach-bold"
              src={`images/app_logo_${i18n.language}.svg`}
            />
            <h2 className="m-0 text-center font-approach-medium text-[2.05rem] font-medium">
              {t('appSubtitle')}
            </h2>
            <div className="relative flex w-full justify-center">
              <h3 className="m-0 w-fit whitespace-pre-wrap bg-white px-[12px] py-0 text-center font-approach-regular text-[1.25rem] font-normal">
                {t('fromTheMuseum')}
              </h3>
            </div>
            <div className="w-[320px]">
              <div className="mb-[12px] w-full rounded-[12px] bg-black px-0 py-[4px] text-center font-approach-medium text-[1.5rem] text-white">
                {t('chooseAndCombine')}
              </div>
              <div className="flex items-center justify-between">
                <SVG className="h-[32px] w-auto" src="/icons/logo.svg" />

                <TotalMotifCount />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null
}

export default Welcome
